/**
 * Normalizes decimal input to ensure proper formatting
 * - Prepends "0" if input starts with "."
 * - Example: ".5" becomes "0.5"
 */
export function normalizeDecimalInput(input: string): string {
  if (input.startsWith(".")) {
    return `0${input}`;
  }
  return input;
}
